import {
  BASE_CUSTOMERS_PATH,
  BASE_INSIGHTS_PATH,
  BASE_ORDERS_PATH,
  BASE_PRODUCTS_PATH,
  BASE_SETTINGS_PATH,
  BASE_SHIPMENTS_PATH,
  ONBOARD_PATH,
  ORDER_DETAILS_MODAL_FULFILLMENT_PLAN_PATH,
  ORDER_DETAILS_MODAL_FULFILLMENT_PLAN_PATH_SEGMENT,
  ORDER_DETAILS_PATH,
  ORDER_DETAILS_RETURN_PATH_SEGMENT,
  ORDER_DETAILS_RETURN_PATH,
  HOME_PAGE_PATH,
  ORDER_DETAILS_ENHANCED_RETURN_PATH,
  ORDER_DETAILS_ENHANCED_RETURN_PATH_SEGMENT,
  BASE_RETURNS_PATH,
  BASE_FULFILLMENTS_PAGE_PATH,
  BASE_SCAN_PATH,
} from '../../routes/constants';

// need to check for trailing slash, so we don't match against `/orders`
const BASE_ORDER_DETAILS_URL_CHUNK = `${ORDER_DETAILS_PATH}/`;

const allowedBaseRoutes = [
  ONBOARD_PATH,
  BASE_INSIGHTS_PATH,
  BASE_ORDERS_PATH,
  BASE_SHIPMENTS_PATH,
  BASE_PRODUCTS_PATH,
  BASE_CUSTOMERS_PATH,
  BASE_SETTINGS_PATH,
  HOME_PAGE_PATH,
  BASE_RETURNS_PATH,
  BASE_FULFILLMENTS_PAGE_PATH,
  BASE_SCAN_PATH,
];

export const OrderDetailsAllowedBaseRoutesRoute = `(${allowedBaseRoutes.join('|')})`;
export const OrderDetailsSalesOrderRoute = `/(.*)?${ORDER_DETAILS_PATH}/:salesOrderId`;
export const OrderDetailsSelectedEntityRoute = `/:entityType(${ORDER_DETAILS_MODAL_FULFILLMENT_PLAN_PATH_SEGMENT}|${ORDER_DETAILS_RETURN_PATH_SEGMENT}|${ORDER_DETAILS_ENHANCED_RETURN_PATH_SEGMENT})?/:entityId?`;
export const OrderDetailsRoute = `${OrderDetailsAllowedBaseRoutesRoute}${OrderDetailsSalesOrderRoute}${OrderDetailsSelectedEntityRoute}`;
export const OrderOverviewRoute = `${OrderDetailsAllowedBaseRoutesRoute}${OrderDetailsSalesOrderRoute}`;

export const isOrderDetailsPath = (pathname) => pathname.includes(BASE_ORDER_DETAILS_URL_CHUNK);

export const createPathnameWithoutOrderDetails = (basePathname) => {
  const orderDetailsPathIndex = basePathname.indexOf(BASE_ORDER_DETAILS_URL_CHUNK);

  return orderDetailsPathIndex < 0 ? basePathname : basePathname.slice(0, orderDetailsPathIndex);
};

export const createOrderDetailsPathname = (basePathname, salesOrderId) => {
  const cleanPathname = createPathnameWithoutOrderDetails(basePathname);

  return `${cleanPathname}${ORDER_DETAILS_PATH}/${salesOrderId}`;
};

export const createOrderDetailsFulfillmentPlanPathname = (basePathname, salesOrderId, fulfillmentPlanId) => {
  const orderDetailsPathname = createOrderDetailsPathname(basePathname, salesOrderId);

  return fulfillmentPlanId
    ? `${orderDetailsPathname}${ORDER_DETAILS_MODAL_FULFILLMENT_PLAN_PATH}/${fulfillmentPlanId}`
    : orderDetailsPathname;
};

export const createOrderDetailsReturnPathname = (basePathname, salesOrderId, returnId, storeSupportsEnhancedReturns = false) => {
  const orderDetailsPathname = createOrderDetailsPathname(basePathname, salesOrderId);
  const returnsPath = storeSupportsEnhancedReturns ? ORDER_DETAILS_ENHANCED_RETURN_PATH : ORDER_DETAILS_RETURN_PATH;

  return returnId ? `${orderDetailsPathname}${returnsPath}/${returnId}` : orderDetailsPathname;
};
